import { render, staticRenderFns } from "./NationalSocialStudies.vue?vue&type=template&id=97d2de4e&scoped=true&"
import script from "./NationalSocialStudies.vue?vue&type=script&lang=js&"
export * from "./NationalSocialStudies.vue?vue&type=script&lang=js&"
import style0 from "./NationalSocialStudies.vue?vue&type=style&index=0&id=97d2de4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d2de4e",
  null
  
)

export default component.exports